/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ThreadListApiV1CollaborationAppThreadGetQueryResponse,
  ThreadListApiV1CollaborationAppThreadGetQueryParams,
  ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  ThreadListApiV1CollaborationAppThreadGet422,
} from '../../types/ThreadListApiV1CollaborationAppThreadGet.ts'
import type { InfiniteData, QueryKey, QueryClient, InfiniteQueryObserverOptions, UseInfiniteQueryResult } from '@tanstack/react-query'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const threadListApiV1CollaborationAppThreadGetInfiniteQueryKey = (params?: ThreadListApiV1CollaborationAppThreadGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/thread' }, ...(params ? [params] : [])] as const

export type ThreadListApiV1CollaborationAppThreadGetInfiniteQueryKey = ReturnType<typeof threadListApiV1CollaborationAppThreadGetInfiniteQueryKey>

/**
 * @summary Thread List
 * {@link /api/v1/collaboration_app/thread}
 */
export async function threadListApiV1CollaborationAppThreadGetInfinite(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<ThreadListApiV1CollaborationAppThreadGetQueryResponse, ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>, unknown>({
    method: 'GET',
    url: `/api/v1/collaboration_app/thread`,
    params,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

export function threadListApiV1CollaborationAppThreadGetInfiniteQueryOptions(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = threadListApiV1CollaborationAppThreadGetInfiniteQueryKey(params)
  return infiniteQueryOptions<
    ThreadListApiV1CollaborationAppThreadGetQueryResponse,
    ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>,
    ThreadListApiV1CollaborationAppThreadGetQueryResponse,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal

      if (params) {
        params['offset'] = pageParam as unknown as ThreadListApiV1CollaborationAppThreadGetQueryParams['offset']
      }
      return threadListApiV1CollaborationAppThreadGetInfinite(params, headers, config)
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1),
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => (firstPageParam <= 1 ? undefined : firstPageParam - 1),
  })
}

/**
 * @summary Thread List
 * {@link /api/v1/collaboration_app/thread}
 */
export function useThreadListApiV1CollaborationAppThreadGetInfinite<
  TData = InfiniteData<ThreadListApiV1CollaborationAppThreadGetQueryResponse>,
  TQueryData = ThreadListApiV1CollaborationAppThreadGetQueryResponse,
  TQueryKey extends QueryKey = ThreadListApiV1CollaborationAppThreadGetInfiniteQueryKey,
>(
  params?: ThreadListApiV1CollaborationAppThreadGetQueryParams,
  headers?: ThreadListApiV1CollaborationAppThreadGetHeaderParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        ThreadListApiV1CollaborationAppThreadGetQueryResponse,
        ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? threadListApiV1CollaborationAppThreadGetInfiniteQueryKey(params)

  const query = useInfiniteQuery(
    {
      ...threadListApiV1CollaborationAppThreadGetInfiniteQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<ThreadListApiV1CollaborationAppThreadGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}